$(document).ready(function () {
    if (!$("#poslovnice-container").length) {
        return;
    }

    $("#slick1").slick({
        mobileFirst: true,
        rows: 2,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: window.innerWidth < window.innerHeight ? 1 : 3,
        slidesToScroll: 1,
    });

    /*function initMap() {
        const map = new google.maps.Map(document.getElementById("map"), {
            center: { lat: 47.3824684, lng: 8.6682494 },
            zoom: 10,
        });

        $('.shops-wrapper .shop-card').each(function () {
            if ($(this).data('lat')) {
                new google.maps.Marker({
                    position: { lat: $(this).data('lat'), lng: $(this).data('lng') },
                    map,
                    title: $(this).data('name'),
                });
            }
        })
    }

    window.initMap = initMap;*/

    $(".news-carousel").slick({
        // dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:
            "<button type='button' class='slick-prev pull-left'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
        nextArrow:
            "<button type='button' class='slick-next pull-right'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,
                    // dots: true
                },
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    // infinite: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });
});
